export const TechFooter = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-slate-400 border-t border-slate-800 text-xs py-12">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
      <div>
        <div className="inline-block bg-white px-3 py-2 mb-3">
          <img src="/assets/logo.png" alt="Saircos - General Contractor Edile" className="h-10 w-auto" />
        </div>
        <p className="text-slate-400 text-xs leading-relaxed font-mono">
          Impresa di costruzioni generali, opere di condomini, ristrutturazioni private ed esecuzione di
          appalti pubblici qualificati SOA.
        </p>
      </div>
      <div>
        <div className="text-white font-mono uppercase tracking-wider mb-3">Mappa Sezioni</div>
        <ul className="space-y-2">
          <li><a href="#dati" className="hover:text-blue-400 transition-colors">Dati &amp; SOA</a></li>
          <li><a href="#progetti" className="hover:text-blue-400 transition-colors">Archivio Opere</a></li>
          <li><a href="#specializzazioni" className="hover:text-blue-400 transition-colors">Specializzazioni</a></li>
          <li><a href="#registro" className="hover:text-blue-400 transition-colors">Protocollo Esecutivo</a></li>
        </ul>
      </div>
      <div>
        <div className="text-white font-mono uppercase tracking-wider mb-3">Dati Societari</div>
        <ul className="space-y-2 text-slate-400 font-mono">
          <li>SAIRCOS S.R.L.</li>
          <li>P.IVA / C.F. 03216710735</li>
          <li>REA MI-2625081</li>
          <li>Capitale sociale € 257.000 i.v.</li>
          <li>SOA n. 11023/63/01 — OG 1 cl. II</li>
        </ul>
      </div>
      <div>
        <div className="text-white font-mono uppercase tracking-wider mb-3">Sedi</div>
        <ul className="space-y-2 text-slate-400 font-mono">
          <li>Legale: Piazza Quattro Novembre 4, 20124 Milano (MI)</li>
          <li>Operativa: Vicolo San Martino 10, 20016 Pero (MI)</li>
          <li>Tel: <a href="tel:+390282396294" data-testid="footer-phone" className="hover:text-blue-400 transition-colors">02 8239 6294</a></li>
          <li>Email: <a href="mailto:info@saircos-spa.it" data-testid="footer-email" className="hover:text-blue-400 transition-colors">info@saircos-spa.it</a></li>
        </ul>
        <a href="#contact" className="inline-block mt-3 text-blue-400 hover:underline font-mono">
          Ufficio gare: vai al modulo →
        </a>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 pt-6 border-t border-slate-800 text-center text-slate-400 font-mono text-[11px]">
      Saircos S.r.l. · Tutti i diritti riservati. ·{" "}
      <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-blue-400 transition-colors">Privacy</a>
    </div>
  </footer>
);
